import { render } from "./BusinessBatches.vue?vue&type=template&id=53bcb6f8&scoped=true"
import script from "./BusinessBatches.vue?vue&type=script&lang=js"
export * from "./BusinessBatches.vue?vue&type=script&lang=js"

import "./BusinessBatches.vue?vue&type=style&index=0&id=53bcb6f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53bcb6f8"]])

export default __exports__